const mask = {
  block: () => {
    document.body.classList.add('blocked-modal-opened');
  },
  inactivate: () => {
    document.body.classList.add('modal-opened');
  },
  reset: () => {
    document.body.classList.remove('modal-opened');
    document.body.classList.remove('blocked-modal-opened');
  }
}

export { mask };